import { Command } from 'pos/common';
import { DeliveryNoteDTO, Permission, DocumentType } from 'core/api';
import { Preconditions } from 'core/infrastructure-next';
import { printDocument } from 'pos/modules/helpers/document-printing';
import { PrintFacade } from 'pos/facades';
import * as DeliveryNoteStore from './DeliveryNoteStore';

declare global {
	interface CommandType {
		printDeliveryNotesProform: (deliveryNotes: DeliveryNoteDTO[]) => Promise<Result>
	}
}

Command.register('printDeliveryNotesProform', Preconditions.and(Preconditions.ensure(Permission.DeliveryNote_Print), Preconditions.ensureIsNotLite), async (deliveryNotes: DeliveryNoteDTO[]): Promise<Result> => {
	const deliveryNoteIds = deliveryNotes.map(x => x.Id);

	const options = await PrintFacade.getPrintOptions(DocumentType.DeliveryNote);
	return printDocument({
		getOptions: () => options,
		print: params => DeliveryNoteStore.printDeliveryNotesProform(deliveryNoteIds, params)
	});
});
